<div class="settings-cog fixed flex items-center justify-center right-0 w-10 h-10 shadow-lg rounded-l-lg z-90 cursor-pointer bg-primary bg-opacity-90 print:hidden"
    [class.lg:right-0]="config.layout === 'centered' || config.layout === 'material'" style="top: 275px;"
    (click)="settingsDrawer.toggle()">
    <!-- <mat-icon class="icon-size-5 text-white animate-ping" [svgIcon]="'heroicons-outline:search'"></mat-icon> -->

    <mat-icon class="icon-size-5 text-white     animate-pulse" [svgIcon]="'heroicons_solid:search'"></mat-icon>


</div>


<fuse-drawer class="h-full min-w-full w-full z-999 " fixed
    [mode]="'over'" [name]="'settingsDrawer'" [position]="'right'" #settingsDrawer>
<div class="h-100 min-w-screen sm:w-100 sm:min-w-100  mt-30 rounded-l-lg ">
    <div class="flex flex-col w-full bg-card ">
        <!-- <div class="flex flex-row items-center px-6 h-20 min-h-20 text-white bg-primary"> -->
        <div class="flex flex-row items-center p-4 h-12 min-h-12 text-white bg-primary">
            <mat-icon class="icon-size-7 text-current" [svgIcon]="'heroicons_solid:search'"></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">Search Account</div>
            <button class="ml-auto" mat-icon-button (click)="close(settingsDrawer)">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>

        <div class="flex flex-col p-4 mt-1">
            <div class="form-group mb-1">
                <div class="sm:col-span-2">
                    <label for="Accountno" class="block text-black font-500 text-lg font-medium mb-1 LABEL">Account
                        No</label>

                    <div class="flex items-center mb-1">
                        <!-- <input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 -->
                        <!-- dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mr-3 mt-2"> -->
                        <div class="w-full mt-1 relative rounded-md shadow-sm">

                            <div class="mt-1 relative rounded-md shadow-sm">
                                <input placeholder="Enter Account No" name="Accountno" id="Accountno" type="text"
                                    formControlName="Accountno"
                                    class="py-2.5 px-4 mb-0 block w-full border-1 border-lightBlue rounded-lg text-lg font-medium placeholder:text-primary focus:border-primary focus:ring-primary"
                                    aria-describedby="email-error" (input)="validateNumber($event)" maxlength="9" />
                              
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="form-group mb-1">
                <div class="sm:col-span-2">
                    <label for="CoreSPID" class="block text-black font-500 text-lg font-medium mb-1 LABEL">Core
                        SPID</label>

                    <div class="flex items-center mb-1">
                        <!-- <input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 -->
                        <!-- dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mr-3 mt-2"> -->
                        <div class="w-full mt-1 relative rounded-md shadow-sm">

                            <div class="mt-1 relative rounded-md shadow-sm">
                                <input placeholder="Enter Core SPID" name="CoreSPID" id="CoreSPID" type="text"
                                    formControlName="CoreSPID"
                                    class="py-2.5 px-4 mb-0 block w-full border-1 border-lightBlue rounded-lg text-lg font-medium placeholder:text-primary focus:border-primary focus:ring-primary"
                                    aria-invalid="true" [(ngModel)]="CoreSPID" aria-describedby="email-error"
                                    (input)="validate($event)" maxlength="10" />
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mb-1">
                <div class="sm:col-span-2">
                    <label for="SPID" class="block text-black font-500 text-lg font-medium mb-1 LABEL">SPID</label>

                    <div class="flex items-center mb-1">
                        <!-- <input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 -->
                        <!-- dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 mr-3 mt-2"> -->
                        <div class="w-full mt-1 relative rounded-md shadow-sm">

                            <div class="mt-1 relative rounded-md shadow-sm">
                                <input placeholder="Enter SPID" name="SPID" id="SPID" type="text" formControlName="SPID"
                                    class="py-2.5 px-4 mb-0 block w-full border-1 border-lightBlue rounded-lg text-lg font-medium placeholder:text-primary focus:border-primary focus:ring-primary"
                                    aria-invalid="true" [(ngModel)]="SPID" aria-describedby="email-error" (input)="validate($event)" 
                                    maxlength="13" />
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-1 p-2">
                <div class="sm:col-span-2 text-center">

               
                        <button type="submit" (click)="onglobalFormSubmit(settingsDrawer)"
                            class="hover:bg-magenta font-medium rounded-full mr-2 text-white bg-primary font-500 text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 text-lg"
                            mat-flat-button [color]="'primary'">
                            Search
                        </button>
                       
                        <button type="submit" (click)="Clear()"
                            class="hover:bg-magenta font-medium rounded-full mr-2 text-white bg-primary font-500 text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 text-lg"
                            mat-flat-button [color]="'primary'">
                            Clear
                        </button>
                 
                </div>


            </div>



        </div>


    </div>
</div>

</fuse-drawer>



<style>
    fuse-drawer.h-full
{ background-color: transparent !important; background: none !important; border: none  !important; box-shadow: none !important;}

.fuse-drawer-content
{ background-color: tr ansparent !important; background: none !important;     width: 100% !important; box-shadow: none !important;
    display: block !important; border: none  !important;}

    .fuse-drawer-content .h-100.min-w-screen
    {float: right !important; border: none  !important; box-shadow: none !important;}

</style>